module.exports = __webpack_public_path__ + "img/art-45.a5f23328.png";